import { render, staticRenderFns } from "./upPwdDialog.vue?vue&type=template&id=2c58e090&scoped=true"
import script from "./upPwdDialog.vue?vue&type=script&lang=js"
export * from "./upPwdDialog.vue?vue&type=script&lang=js"
import style0 from "./upPwdDialog.vue?vue&type=style&index=0&id=2c58e090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58e090",
  null
  
)

export default component.exports